"use client";

import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";
import style from "./Expertise.module.scss";
import ExpertiseList from "./ExpertiseList/ExpertiseList";

interface ExpertiseProps {
  expertiseSection: any;
  background?: string;
  slug?: string;
}

export const Expertise = ({
  expertiseSection,
  background,
  slug,
}: ExpertiseProps) => {
  if (!expertiseSection || expertiseSection?.cardsServices?.length === 0)
    return null;
  const filterCards = expertiseSection?.cardsServices?.filter(
    (card) => card.slug !== slug
  );
  return (
    <section
      className={`${style.wrap} ${background ? style.primary : style.transparent}`}
    >
      <div className="container">
        <TitleAnimation
          messages={{
            first_word: expertiseSection.first_words,
            second_word: expertiseSection.second_words,
          }}
        />
      </div>
      <ExpertiseList slug={slug} cardsServices={filterCards} />
    </section>
  );
};
